import React from 'react';
import AddPackageComponent from '../../../Components/Package/AddPackage';

export default function AddPackage() {
    return (
        <div className='page-body'>
            <AddPackageComponent />
        </div>
    );
}